<template>
  <div>
    <v-list>
      <v-divider></v-divider>
      <v-list-item link to="/dashboard" dense>
        <v-list-item-icon class="mr-4">
          <v-icon small color="light-blue">mdi-view-dashboard</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="white--text">
            {{ $t("Dashboard") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item
        link
        to="/dashboard/messages"
        dense
        v-if="count && count != 0"
      >
        <v-list-item-icon class="mr-4">
          <v-icon small color="light-blue">mdi-message</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="white--text">
            {{ $t("Messages") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item link to="/dashboard/bookings" dense>
        <v-list-item-icon class="mr-4">
          <v-icon small color="light-blue">mdi-calendar-month</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="white--text">
            {{ $t("Bookings") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item link to="/dashboard/reviews" dense>
        <v-list-item-icon class="mr-4">
          <v-icon small color="light-blue">mdi-comment-text-multiple</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="white--text">
            {{ $t("Reviews") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item link to="/dashboard/account/edit" dense>
        <v-list-item-icon class="mr-4">
          <v-icon small color="light-blue">mdi-account-edit</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="white--text">
            {{ $t("EditAccount") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item link @click="resetPass" dense>
        <v-list-item-icon class="mr-4">
          <v-icon small color="light-blue">mdi-lock-reset</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="white--text">
            {{ $t("ChangePassword") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
    </v-list>
    <v-subheader v-if="$store.state.user.role === 'Host'" dark class="black">{{
      $t("PartnerDashboard")
    }}</v-subheader>
    <v-list v-if="$store.state.user.role === 'Host'">
      <v-list-item link to="/dashboard/partner/listings" dense>
        <v-list-item-icon class="mr-4">
          <v-icon small color="light-blue">mdi-folder-home</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="white--text">
            {{ $t("Properties") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item link to="/dashboard/partner/bookings" dense>
        <v-list-item-icon class="mr-4">
          <v-icon small color="light-blue">mdi-calendar-month</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="white--text">
            {{ $t("Bookings") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item link to="/dashboard/partner/payouts" dense>
        <v-list-item-icon class="mr-4">
          <v-icon small color="light-blue"
            >mdi-credit-card-settings-outline</v-icon
          >
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="white--text">
            {{ $t("string13") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
    </v-list>
    <WaitDialogComponent :waitDialog="waitDialog" />
  </div>
</template>

<script>
import WaitDialogComponent from "@/components/layout/WaitDialogComponent.vue";
import AuthService from "@/services/AuthService";
import swal from "sweetalert";

export default {
  components: { WaitDialogComponent },
  data() {
    return {
      waitDialog: false,
      count: null
    };
  },
  created() {
    if (this.$store.getters.isLoggedIn) {
      var token = this.$store.state.token;
      AuthService.getMessageTopicsCount({
        headers: { Authorization: "Bearer " + token }
      })
        .then(result => {
          this.count = result.data;
        })
        .catch(err => {
          this.error = err.response.data.error;
        });
    }
  },
  methods: {
    resetPass() {
      swal({
        text: this.$t("PassChangeMsg"),
        className: "custom-confirm",
        buttons: {
          cancel: this.$t("No"),
          confirm: this.$t("Yes")
        }
      }).then(value => {
        if (value) {
          this.$store.dispatch("logout").then(() => {
            this.$router.push({
              name: "ResetPassword"
            });
          });
        }
      });
    }
  }
};
</script>

<style></style>
